import { pedagogico } from "@/constants/pedagogico";
import { secretaria_financeiro } from "@/constants/secretaria_financeiro";

function getServicos(setor) {

  if (setor === "comercial") {
    
    return []
  }

  if (setor === "all") {
    const servicos_pedagogico = pedagogico
    const servicos_secretaria_financeiro = secretaria_financeiro
    const servicos = servicos_pedagogico.concat(servicos_secretaria_financeiro);

    return servicos.map(item => ({ id: item.id, label: item.label }))
  }

  const servicos = setor === "pedagogico" ? pedagogico : secretaria_financeiro
  
  return servicos.map(item => ({ id: item.id, label: item.label }))
}

export default getServicos;
